module.exports = __webpack_public_path__ + "static/media/filter-blue.a120ee84.svg";